import { ReactElement, useEffect, useCallback } from 'react';
import { useNavigate, useMatch } from 'react-router-dom';
import API from 'app/utils/api/axios';
import API_URL from 'app/constants/api_urls';
import LoadingScreen from 'app/components/elements/loading_screen/loading_screen';
import URL from 'app/constants/route_urls';

function VerifyEmail(): ReactElement {
    const navigate = useNavigate();
    const match = useMatch(URL.VERIFY_EMAIL);

    const verifyEmailWithCallback = useCallback(
        async (key: string) => {
            try {
                await API.post(API_URL.VERIFY_EMAIL, { key });
                navigate(`${URL.PROFILE}?verified=true`);
            } catch (error) {
                navigate(`${URL.PROFILE}?verified=false`);
            }
        },
        [navigate]
    );

    useEffect(() => {
        if (match && match?.params?.key) verifyEmailWithCallback(match.params.key);
    }, [match, verifyEmailWithCallback]);

    return <LoadingScreen type='layout' />;
}

export default VerifyEmail;
